class BlockBadgeDiscount extends CustomElement {
    constructor() {
        super();

        this.state = {
            compareAtPrice: 0,
            price: 0,
        };

        this.props = {
            colorSettings: [],
            structure: "",
        };
    }

    connectedCallback() {
        this.initProps();
        this.initState();
        this.render();
    }

    initProps() {
        this.props = {
            structure: this.getAttribute(":structure"),
            colorSettings: [...this.getColorSettings()],
        };
    }

    initState() {
        this.state = {
            compareAtPrice: parseInt(this.getAttribute(":compareAtPrice")),
            price: parseInt(this.getAttribute(":price")),
        };
    }

    calculateDiscountPercent() {
        const { compareAtPrice, price } = this.state;
        let discountPercent = ((compareAtPrice - price) * 100) / compareAtPrice;
        return discountPercent.toFixed(0);
    }

    getDiscountPercentageText(discountPercent) {
        const { structure } = this.props;

        let discountPercentageText = "";

        if (!discountPercent || discountPercent == 0) return "";

        discountPercentageText = structure.replace(
            "discount_percent",
            discountPercent
        );

        return discountPercentageText;
    }

    getColorSettings() {
        const inputs = document.querySelectorAll("#product-badge-settings input");

        let bgColorArr = [];

        if (inputs?.length == 0) {
            return bgcCodeArr;
        }

        inputs.forEach((item) => {
            bgColorArr.push({
                from: parseInt(item.getAttribute("data-from")),
                to: parseInt(item.getAttribute("data-to")),
                colorCode: item.getAttribute("data-color-code"),
            });
        });

        return bgColorArr;
    }

    getDiscountPercentageBackground(discount) {
        const discountPercent = parseInt(discount);

        let badgeBackgroundColor = '#DA1F00';

        if (!!discountPercent && !isNaN(discountPercent)) {
            let result = this.props.colorSettings.find(({ to, from }) => {
                if ((discountPercent === from && discountPercent === to) || (!from && discountPercent === to) || (!to && discountPercent === from)) {
                    return true;
                } else if (from <= discountPercent && discountPercent < to) {
                    return true;
                }
                return false;
            });
            if (!!result && !!result.colorCode) {
                badgeBackgroundColor = result.colorCode.toUpperCase();
            }
        }

        return badgeBackgroundColor;
    }

    render() {
        const { compareAtPrice, price } = this.state; 

        if (!compareAtPrice || !price) return "";
      
        const discountPercent = this.calculateDiscountPercent();
        const discountPercentageText = this.getDiscountPercentageText(discountPercent);
        const background = this.getDiscountPercentageBackground(discountPercent);

        if (!discountPercent || isNaN(discountPercent)) return "";

        this.innerHTML = `
            <div class="bg-[${background}] text-[1.3rem] text-white font-bold rounded-md flex justify-center items-center px-3 h-full">
                ${discountPercentageText}
            </div>
        `;
    }
}

customElements.define("product-block-badge-discount", BlockBadgeDiscount);
